import type { FormField } from '@elfsight/widget-form-builder/widget';
import { useLingui } from '@lingui/react/macro';

export const useGetterInvalidFieldErrorMessage = () => {
  const { t } = useLingui();

  const messages: Partial<Record<FormField['type'], string>> = {
    phone: t`Please enter a valid phone`,
    email: t`Please enter a valid email`,
    URL: t`Please enter a valid URL`,
    number: t`Please enter a valid number`
  };

  return ({ type, name }: FormField): string => {
    return messages[type] ?? `Please enter a valid ${name}`;
  };
};
